exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntr.el-table__row.drop-row {\n  cursor: grabbing;\n}\ntr.el-table__row.drop-row td {\n  border: 1px dotted;\n}\n.q-btn--fab .q-btn__wrapper {\n  min-height: 35px;\n  min-width: 35px;\n}\n.search.x-row {\n  align-items: flex-start;\n}\n.has-more {\n  color: red;\n  font-weight: 700;\n}\n.row-canceled {\n  text-decoration: line-through;\n}\n", ""]);

// exports
